import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getOrdersURL, getOrderURL } from '../api';
import moment from 'jalali-moment'

// initial state
export const initialState = {
  loading: false,
  error: false,
  currentPageIndex : 0,
  hasMore : true,
  items: [],
 
  fetchPermission : true,//برای مواقعی که بک زده میشه از یک فاکتور به فهرست نمیخواهیم مجدد لود شود

  selectedOrder : {},
  selectedOrderId : '',

  searchKey : '',
  searchKey_fromdate : '',
  searchKey_todate : '',
  searchKey_lensTitle : '',
  searchKey_lensType : '',
  searchKey_cyll : '',
  searchKey_cylr : '',
  searchKey_sphl : '',
  searchKey_sphr : '',
  searchKey_consumer : '',
  searchKey_storeName : '',
  searchKey_finalUserSearch : '',
  searchKey_finalCreatorSearch : '',
  searchKey_addr : '',
  searchKey_addl : '',
  searchKey_state : ''
};

// our slice
const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    setOrderLoading: (state) => {
      state.loading = true;
    },
    setOrderLoadingFalse : (state)=>{
      state.loading = false;
    },
    setOrderSearchKey : (state, { payload }) =>{
      state.searchKey = payload;
    },
    setOrderLensTypeSearchKey : (state, { payload }) =>{
      state.searchKey_lensType = payload;
    },
    setOrderCoatingSearchKey : (state, { payload }) =>{
      state.searchKey_coating = payload;
    },
    setOrderLensTitleSearchKey : (state, { payload }) =>{
      state.searchKey_lensTitle = payload;
    },
    setOrderADDRSearchKey : (state, { payload }) =>{
      state.searchKey_addr = payload;
    },
    setOrderADDLSearchKey : (state, { payload }) =>{
      state.searchKey_addl = payload;
    },
    setOrderStoreNameSearchKey : (state, { payload }) =>{
      state.searchKey_storeName = payload;
    },
    setOrderDescriptionSearchKey: (state, { payload }) =>{
      state.searchKey_description = payload;
    },
    setOrderConsumerSearchKey : (state, { payload }) =>{
      state.searchKey_consumer = payload;
    },
    setOrderStateSearchKey : (state, { payload }) =>{
      state.searchKey_state = payload;
    },
    setOrderFinalUserSearchSearchKey : (state, { payload }) =>{
      state.searchKey_finalUserSearch = payload;
    },
    setOrderFinalCreatorSearchSearchKey : (state, { payload }) =>{
      state.searchKey_finalCreatorSearch = payload;
    },
    setOrderCYLRSearchKey : (state, { payload }) =>{
      state.searchKey_cylr = payload;
    },
    setOrderCYLLSearchKey : (state, { payload }) =>{
      state.searchKey_cyll = payload;
    },
    setOrderSPHLSearchKey : (state, { payload }) =>{
      state.searchKey_sphl = payload;
    },
    setOrderSPHRSearchKey : (state, { payload }) =>{
      state.searchKey_sphr = payload;
    },
    setOrderSearchKeyFromdate : (state, { payload }) =>{
      state.searchKey_fromdate = payload;
    },
    setOrderSearchKeyTodate : (state, { payload }) =>{
      state.searchKey_todate = payload;
    },
    setOrderItems: (state, { payload }) => {
      state.loading = false;
      state.error = false;
      state.items.push(...payload);
      if(payload.length === 0){
        state.hasMore = false;
      }
      console.log("newItems count is " + (payload.length));
      state.currentPageIndex++;
    },
    setSelectedOrderId: (state, { payload }) => {
      state.loading = false;
      state.error = false;
      console.log("selectedOrderId");
      state.fetchPermission = false;// یعنی وارد یک فاکتور شدیم و دیگه مجدد لود نکنه اطلاعات رو
      state.selectedOrderId = payload;
    },

    setSelectedOrder: (state, { payload }) => {
      state.loading = false;
      state.error = false;
      state.selectedOrder = payload;
      state.selectedOrderId = payload.ID;
      state.fetchPermission = false;
    },
    setOrderError: (state) => {
      state.error = true;
    },
    clearOrderItems: (state) => {
      state.items = [];
      state.currentPageIndex = 0;
      state.selectedOrder = {};
      state.selectedOrderId = '';
    },
    clearSelectedOrder: (state) => {
      state.selectedOrder = {};
      state.selectedOrderId = '';
    },
    clearOrderFilters: (state) => {
      state.searchKey = '';
      state.searchKey_fromdate = '';
      state.searchKey_todate = '';
      state.searchKey  = '';
      state.searchKey_fromdate  = '';
      state.searchKey_todate  = '';
      state.searchKey_lensTitle = '';
      state.searchKey_lensType ='';
      state.searchKey_cyll = '';
      state.searchKey_cylr = '';
      state.searchKey_sphl = '';
      state.searchKey_sphr = '';
      state.searchKey_addr = '';
      state.searchKey_addl = '';
      state.searchKey_storeName = '';
      state.searchKey_consumer = '';
      state.searchKey_finalUserSearch = '';
      state.searchKey_finalCreatorSearch = '';
      state.searchKey_coating = '';
      state.searchKey_state = '';
    },
    clearOrderData: (state) => {
      
      state.loading = false;
      state.error = false;
      state.currentPageIndex = 0;
      state.items = [];
      state.selectedOrder = {};
      state.selectedOrderId = '';
      state.hasMore = true;
      state.searchKey  = '';
      state.searchKey_fromdate  = '';
      state.searchKey_todate  = '';
      state.searchKey_lensTitle = '';
      state.searchKey_lensType ='';
      state.searchKey_cyll = '';
      state.searchKey_cylr = '';
      state.searchKey_sphl = '';
      state.searchKey_sphr = '';
      state.searchKey_addr = '';
      state.searchKey_addl = '';
      state.searchKey_storeName = '';
      state.searchKey_consumer = '';
      state.searchKey_finalUserSearch = '';
      state.searchKey_finalCreatorSearch = '';
      state.searchKey_coating = '';
      state.fetchPermission = true;
      state.searchKey_state = '';
    }
  },
});

// export the actions
export const { setOrderLoading, setOrderLoadingFalse, setOrderItems, setOrderError, clearOrderData,setOrderSearchKey, setOrderSearchKeyFromdate, setOrderSearchKeyTodate,clearOrderItems ,clearOrderFilters, setSelectedOrder , setSelectedOrderId, clearSelectedOrder,
  setOrderLensTypeSearchKey,
  setOrderLensTitleSearchKey ,
  setOrderCYLRSearchKey ,
  setOrderCYLLSearchKey,
  setOrderSPHLSearchKey ,
  setOrderSPHRSearchKey ,
  setOrderADDRSearchKey ,
  setOrderADDLSearchKey,
  setOrderStoreNameSearchKey,  
  setOrderDescriptionSearchKey,
  setOrderConsumerSearchKey ,
  setOrderStateSearchKey,
  setOrderFinalUserSearchSearchKey ,
  setOrderFinalCreatorSearchSearchKey,
  setOrderCoatingSearchKey
} = ordersSlice.actions;

// export the selector (".items" being same as in slices/index.js's "items: something")
export const orderItemsSelector = (state) => state.items;

// export the default reducer
export default ordersSlice.reducer;


// fetch all items
export function fetchOrders(input) {
  return async (dispatch) => {
    console.log("input");
    console.log(input);

    var _fd = "";
    if(input.fromdate !== null && input.fromdate !== '' && input.fromdate !== undefined){
    _fd = moment.from(input.fromdate, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);
    }
    var _td = "";
    if(input.todate !== null && input.todate !== '' && input.todate !== undefined){
    _td = moment.from(input.todate, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);
    }
    if(input.pageindex === 0)
      dispatch(clearOrderItems());

    if(input.hasMore){
      dispatch(setOrderLoading());
      await axios.post(getOrdersURL()+'?searchKey='+input.searchKey+
      '&searchNumber='+''+'&pageIndex='+input.pageindex + '&justPreStates='+ input.justPreStates +
      (input.searchKey_cyll !== "" && input.searchKey_cyll !== undefined ? "&cyll="+input.searchKey_cyll : "") + 
      (input.searchKey_cylr !== "" && input.searchKey_cylr !== undefined ? "&cylr="+input.searchKey_cylr : "") + 
      (input.searchKey_sphl !== "" && input.searchKey_sphl !== undefined ? "&sphl="+input.searchKey_sphl : "") + 
      (input.searchKey_sphr !== "" && input.searchKey_sphr !== undefined ? "&sphr="+input.searchKey_sphr : "") +
      (input.searchKey_addl !== "" && input.searchKey_addl !== undefined ? "&addl="+input.searchKey_addl : "") +
      (input.searchKey_addr !== "" && input.searchKey_addr !== undefined ? "&addr="+input.searchKey_addr : "") +
      (input.searchKey_consumer !== "" && input.searchKey_consumer !== undefined ? "&consumer="+input.searchKey_consumer : "") + 
      (input.searchKey_state !== "" && input.searchKey_state !== undefined ? "&state="+input.searchKey_state : "") + 
      (input.searchKey_storeName !== "" && input.searchKey_storeName !== undefined ? "&storeName="+input.searchKey_storeName : "") + 
      (input.searchKey_finalUserSearch !== "" && input.searchKey_finalUserSearch !== undefined ? "&finalUserSearch="+input.searchKey_finalUserSearch : "") + 
      (input.searchKey_lensTitle !== "" && input.searchKey_lensTitle !== undefined ? "&lensTitle="+input.searchKey_lensTitle : "") + 
      (input.searchKey_lensType !== "" && input.searchKey_lensType !== undefined ? "&lensType="+input.searchKey_lensType : "")+
      (input.searchKey_coating !== "" && input.searchKey_coating !== undefined ? "&coating="+input.searchKey_coating : "")+
      (input.searchKey_description !== "" && input.searchKey_description !== undefined ? "&description="+input.searchKey_description : "")+
      '&fromDate='+_fd+'&toDate='+_td+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {
          dispatch(setOrderItems(response.data));
      }).catch(function (err) {
        dispatch(setOrderError());
      }).finally(()=> {

      });
  }
  };
}


export function clearOrders() {
  return async (dispatch) => {

      dispatch(clearOrderData());
   
  };
}